import { computed, type Ref } from 'vue';

import { PropertyPurpose } from '@/helpers/const';
import { useFeatureFlags } from '@/helpers/useFeatureFlags';

/**
 * Negative Gearing (FY27) display logic for a property asset, shared across the
 * broker and ERHL asset cards.
 *
 * Mirrors the incoming-property behaviour:
 * - "Is the property a new build?" shows when FY27 is active and the asset is an
 *   investment property.
 * - "Was the contract exchange date on or before 12 May 2026?" shows only when
 *   the asset is not a new build.
 *
 * @param propertyPurpose The asset's property purpose
 * @param isNewBuild The asset's new-build answer
 */
export const useNegativeGearingFy27Asset = (
  propertyPurpose: Ref<string | undefined>,
  isNewBuild: Ref<boolean | undefined>,
) => {
  const { isNegativeGearingFy27Enabled } = useFeatureFlags();

  const showNewBuild = computed(
    () => isNegativeGearingFy27Enabled() && propertyPurpose.value === PropertyPurpose.INVESTMENT_PROPERTY,
  );

  const showContractExchange = computed(() => showNewBuild.value && isNewBuild.value === false);

  return { showNewBuild, showContractExchange };
};
